// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NoEventsOverlay_overlay__Uzh-1","inner":"NoEventsOverlay_inner__15wUT"};